(function () {
  'use strict';

  function initHeroSliderV1(root) {
    if (!root || root.getAttribute('data-hsv1-bound') === '1') return;
    root.setAttribute('data-hsv1-bound', '1');

    var panels = Array.from(root.querySelectorAll('[data-hsv1-panel]'));
    var pills = Array.from(root.querySelectorAll('[data-hsv1-pill]'));
    var count = panels.length;
    if (!count) return;

    var current = 0;
    panels.forEach(function (panel, i) {
      if (panel.classList.contains('is-active')) current = i;
    });

    function showSlide(index) {
      if (index < 0) index = count - 1;
      if (index >= count) index = 0;
      current = index;
      panels.forEach(function (panel, i) {
        panel.classList.toggle('is-active', i === index);
      });
      pills.forEach(function (pill, i) {
        var on = i === index;
        pill.classList.toggle('is-active', on);
        pill.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    pills.forEach(function (pill, i) {
      pill.addEventListener('click', function () {
        showSlide(i);
      });
    });

    var startX = 0;
    var isSwiping = false;

    root.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches[0]) return;
      startX = e.touches[0].clientX;
      isSwiping = true;
    }, { passive: true });

    root.addEventListener('touchmove', function (e) {
      if (!isSwiping || !e.touches || !e.touches[0]) return;
      var diff = startX - e.touches[0].clientX;
      if (Math.abs(diff) > 50) {
        showSlide(current + (diff > 0 ? 1 : -1));
        isSwiping = false;
      }
    }, { passive: true });

    root.addEventListener('touchend', function () {
      isSwiping = false;
    }, { passive: true });

    showSlide(current);
  }

  function initAllHeroSliderV1() {
    document.querySelectorAll('[data-hsv1]').forEach(initHeroSliderV1);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllHeroSliderV1);
  } else {
    initAllHeroSliderV1();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    if (event.target.querySelector('[data-hsv1]')) initAllHeroSliderV1();
  });
})();
